export default __webpack_public_path__ + "static/media/partner1.9f76b978.svg";